import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Duvidas } from '../../components/Duvidas/Duvidas';
import { FooterSiteV1 } from '../../components/FooterSite/v1';
import { NavBarSiteV1 } from '../../components/NavBarSite/_v1/Index';
import { PopUpIframe } from '../../components/PopUpIframe';
import { ShowFadeHidden } from '../../components/ShowFadeHidden';
import { ShowFadeInUpSection } from '../../components/ShowFadeInUpSection';
import { ShowFadeLeftRightSection } from '../../components/ShowFadeLeftRightSection';
import { ShowFadeRightLeftSection } from '../../components/ShowFadeRightLeftSection';
import { SideMenu } from '../../components/SideMenu';
import svg_android from '../global/img/android.svg';
import './Style.css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { LINKS_CENTRAL_DE_AJUDA, LINKS_NAV_PARA_CLIENTES, LINKS_TERMOS } from '../../Links';
import { API_V2_AUTHENTICATED } from '../../api/v2/routes/auth';
import { EstablishmentCards } from '../../components/EstablishmentCards/Index';
import { VideoEmbed } from '../../components/VideoEmbed';
import { utils_site_ref_launch_app, utils_site_ref_yes } from '../../components/utils/utils_site_ref';
import { GLOBAL_LINKS_BAIXAR_ANDROID, GLOBAL_LINKS_BAIXAR_APP, GLOBAL_LINKS_CADASTRE_SE, GLOBAL_LINKS_IFRAME_ENCATES, GLOBAL_LINKS_IFRAME_MURAL, GLOBAL_LINKS_IFRAME_RADAR_GALLERY_PREVIEW } from '../global/links';
import { ViewTooMeFeaturePopup } from './ViewTooMeFeaturePopup';
import { ViewTooMeFeatures } from './ViewTooMeFeatures';
import { ViewHomeBannerList } from './ViewHomeBannerList';

//urls iframes
//const yt_video_id = 'HpUyGTG3S60';//antigo vídeo
const yt_video_id = '7mwOsVUsp-w';
//ta pegando thum desse vídeo: a9j-EEOiWSU , pois o shorts não está permitindo trocar a miniatura
//

export function SiteTemporario() {

    const iframeEncartesPopupRef = useRef();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [state, setState] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        if (!state)
            setState(true);
        else {
            utils_site_ref_yes();

            (async () => { setIsAuthenticated(await API_V2_AUTHENTICATED()) })();
            //  window.scrollTo({ top: 0, behavior: 'instant' });
            //para acelerar no carregamento, os iframes são definidos depois, suas url's
            //


            document.body.style.backgroundColor = 'gainsboro';

            ShowFadeInUpSection('msg_estabelecimento');
            ShowFadeInUpSection('problemas');
            ShowFadeInUpSection('lista-inteligente');
            ShowFadeInUpSection('lista-container');
            ShowFadeInUpSection('container-refer');
            ShowFadeInUpSection('toome');
            ShowFadeInUpSection('pos-vantagens');
            ShowFadeInUpSection('vantagens_topicos');
            ShowFadeInUpSection('containe-diferenciais');
            ShowFadeInUpSection('localidades');
            ShowFadeInUpSection('container-estab');
            ShowFadeInUpSection('usuarios');
            ShowFadeInUpSection('outras_funcionalidades');
            ShowFadeInUpSection('diferenciais');
            ShowFadeInUpSection('impactos');
            ShowFadeInUpSection('icon_social');
            ShowFadeInUpSection('icon_sustentabilidade');
            ShowFadeInUpSection('apoio-toome-container');
            ShowFadeInUpSection('apoio-toome');
            ShowFadeInUpSection('baixar');
            ShowFadeInUpSection('duv');
            ShowFadeInUpSection('contato');

            {///Animação das mensagens
                {//esconder mensagens
                    ShowFadeHidden('anim-left-right-cliente-1');
                    ShowFadeHidden('anim-right-left-toome1-1');
                    ShowFadeHidden('anim-left-right-cliente-2');
                    ShowFadeHidden('anim-right-left-toome1-2');
                }
                {//execução em cascata
                    const tempoEntreMensagens = .7;//1 segundo de uma para outra
                    ShowFadeLeftRightSection('anim-left-right-cliente-1', tempoEntreMensagens, () => {
                        ShowFadeRightLeftSection('anim-right-left-toome1-1', tempoEntreMensagens, () => {
                            ShowFadeLeftRightSection('anim-left-right-cliente-2', tempoEntreMensagens, () => {
                                ShowFadeRightLeftSection('anim-right-left-toome1-2', tempoEntreMensagens);
                            });
                        });
                    });
                }
            }  ///
            const message = searchParams.get('message');
            if (message) {
                alert(message);
                navigate('../');
                window.location.reload();
                return;
            }

            const faqSection = document.getElementById('js_link_container_fac');
            const js_container_fac = document.getElementById('js_container_fac');
            const faq_topic = document.getElementsByName("faq_topic");
            if (faqSection !== null && js_container_fac !== null && faq_topic !== null) {
                js_container_fac.style.display = '';
                faqSection.addEventListener('click', function () {
                    js_container_fac.style.display = js_container_fac.style.display == '' ? 'block' : '';
                });
                faq_topic.forEach(function (topic) {
                    topic.addEventListener('click', function () {
                        const answer = this.nextElementSibling;
                        answer.style.display = (answer.style.display === 'none' || answer.style.display === '') ? 'block' : 'none';
                        if (!topic.classList.contains('faq_topic_sel'))
                            topic.classList.add('faq_topic_sel')
                        else
                            topic.classList.remove('faq_topic_sel')
                    });
                    topic.click();
                    topic.click();
                });
            }
        }
    }, [state])

    const [featuresPopup, setFeaturesPopup] = useState(-1);
    const handleSubmitCadastro = (event) => {
        event.preventDefault();
        const data = new FormData(event.target);

        const params = new URLSearchParams({
            name: data.get("name"),
            email: data.get("email"),
            refCode: data.get("refCode"),
        });

        // 🔑 monta a URL corretamente com hash + query
        const redirectUrl = `${GLOBAL_LINKS_CADASTRE_SE}&${params.toString()}`;
        window.location.href = redirectUrl;
    };

    return <>
        <NavBarSiteV1 />
        <main className='containerSiteTemporario'>

            <div className="body" id="wait_api_load" style={{ display: 'none' }}>
                <svg className="ip" viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="grad1" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%" stopColor="#5ebd3e" />
                            <stop offset="33%" stopColor="#ffb900" />
                            <stop offset="67%" stopColor="#f78200" />
                            <stop offset="100%" stopColor="#e23838" />
                        </linearGradient>
                        <linearGradient id="grad2" x1="1" y1="0" x2="0" y2="0">
                            <stop offset="0%" stopColor="#e23838" />
                            <stop offset="33%" stopColor="#973999" />
                            <stop offset="67%" stopColor="#009cdf" />
                            <stop offset="100%" stopColor="#5ebd3e" />
                        </linearGradient>
                    </defs>
                    <g fill="none" strokeLinecap="round" strokeWidth="3">
                        <g className="ip__track" stroke="#ddd">

                            <polygon points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                            <polygon style={{ transform: 'translate(50px, 50px)' }}
                                points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                        </g>
                        <g strokeDasharray="100 300">
                            <polygon className="ip__worm1" stroke="url(#grad2)"
                                points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                            <polygon className="ip__worm2" stroke="url(#grad1)" style={{ transform: 'translate(50px, 50px)' }}
                                points="100 0, 0 0, 0 5, 95 5, 95 95, 5 95, 5 5, 0 5, 0 100, 100 100" />
                        </g>
                    </g>
                </svg>
                <p>Enviando. Aguarde...</p>
            </div>

            <ViewTooMeFeaturePopup
                isAuthenticated={isAuthenticated}
                featuresPopup={featuresPopup}
                setFeaturesPopup={setFeaturesPopup}
            />

            <main>

                <ViewHomeBannerList />

                <div className='msg_estabelecimento'>
                    <b>Chega de acessar vários links, sites e redes sociais.</b>
                    <p>
                        O <b>TooMe</b> é uma plataforma inteligente de consumo e inteligência de mercado que utiliza IA para transformar dados de preços em economia para consumidores e insights estratégicos para o varejo alimentar.
                    </p>
                </div>

                <section className='funcoes'>
                    <section className="toome_oferece">
                        <ViewTooMeFeatures
                            featuresPopup={featuresPopup}
                            setFeaturesPopup={setFeaturesPopup}
                            iframeEncartesPopupRef={iframeEncartesPopupRef}
                        />
                    </section>
                </section>

                <section className='toome'>
                    <h2 style={{ color: 'var(--cor_tooMe)' }}>Chega de acessar vários links, sites e redes sociais.</h2>
                    <p>
                        O <b>TooMe</b> é uma plataforma inteligente de consumo e inteligência de mercado que utiliza IA para transformar dados de preços em economia para consumidores e insights estratégicos para o varejo alimentar.
                    </p>
                </section>


                <spam>
                    <section className='toome toome_2'>
                        <h3>Confira as ofertas do dia</h3>
                    </section>
                    <section className='container-refer ContainerOfertasDoDia'>
                        <iframe
                            src={GLOBAL_LINKS_IFRAME_RADAR_GALLERY_PREVIEW()}
                            loading='lazy'
                            width="100%"
                            height="100"
                            title='Exibição do mural'
                        />
                    </section>
                </spam>



                <section className='toome toome_2'>
                    <h3>Poste uma oferta no aplicativo e ajude outros consumidores!</h3>
                </section>
                <section className='container-refer container_mural' id='external_iframe_mural'>
                    <iframe
                        src={GLOBAL_LINKS_IFRAME_MURAL()}
                        loading='lazy'
                        width="100%"
                        height="600"
                        title='Exibição do mural'
                    />
                </section>


                <section className='container-refer container_fundo_decorativo_1'>

                    <div>
                        <img
                            src={require('./img/13.avif')}
                            alt="Imagem de uma mulher segurando celular"
                            loading='lazy'
                            width={400}
                            height={400}
                        />

                        <section>
                            <div className="cliente anim-left-right-cliente-1">
                                <p>Preciso ir ao mercado... mas em qual eu vou?</p>
                            </div>
                            <div className="toome1 anim-right-left-toome1-1">
                                <p>Olá! O TooMe te ajuda a escolher o mercado com as melhores ofertas perto de você! 🛒📍</p>
                            </div>
                            <div className="cliente anim-left-right-cliente-2">
                                <p>Sério? E como eu vejo isso?</p>
                            </div>
                            <div className="toome1 anim-right-left-toome1-2">
                                <p>É simples! Baixe o nosso app e compare os preços do dia.<br /> Fácil, rápido e econômico! 💸</p>
                            </div>
                        </section>
                    </div>

                    <p>Com o <b>TooMe</b>, você tem o poder de decisão de compras na palma da mão. <b>Precisa ir ao mercado? O TooMe mostra qual escolher</b>. Simples assim!</p>

                </section>

                <section id="lista-inteligente">
                    <div className="lista-container">
                        <div className="lista-texto">
                            <h2>🧠 Antes de sair de casa, deixe a IA do TooMe montar sua rota de economia!</h2>
                            <p>
                                Selecione os produtos que você quer comprar e o TooMe mostra
                                automaticamente:
                            </p>

                            <div className="beneficios-cards">
                                <div className="beneficio-card">
                                    <span className="emoji">🛒</span>
                                    <p>
                                        Onde estão os <strong>MAIORES descontos</strong>
                                    </p>
                                </div>

                                <div className="beneficio-card">
                                    <span className="emoji">🚗</span>
                                    <p>
                                        As <strong>MELHORES rotas</strong> para economizar tempo, dinheiro e combustível
                                    </p>
                                </div>

                                <div className="beneficio-card">
                                    <span className="emoji">📍</span>
                                    <p>
                                        Os mercados com <strong>MAIS produtos da sua lista</strong>
                                    </p>
                                </div>

                                <div className="beneficio-card">
                                    <span className="emoji">🤖</span>
                                    <p>
                                        Tudo isso com o poder da <strong>IA do TooMe</strong>
                                    </p>
                                </div>
                            </div>

                            <p className="lista-destaque">
                                Use os filtros da Lista Inteligente e descubra o caminho mais rápido para economizar até <b>75%</b> nas compras!
                            </p>
                        </div>

                        <div className="lista-celular">
                            <img
                                src={require("./img/listaCel2.avif")}
                                alt="Tela do app TooMe mostrando a lista inteligente"
                                className="imagem-celular"
                            />
                        </div>
                    </div>
                </section>

                <section className='usuarios'>

                    <h2>Quanto mais pessoas, mais poderosa se torna a inteligência que guia o aplicativo.</h2>
                    <p>Cada oferta <b>compartilhada</b> representa uma economia real para outro usuário, enquanto os mercados ganham mais visibilidade, relevância e destaque.</p>

                </section>

                <section className="vantagens_topicos">
                    <div>
                        <h1>Monitor de preços inteligente? o <b>TooMe</b> tem!</h1>

                        <ul>
                            <li>🔍 Busque seus produtos favoritos pelo nome.</li>
                            <li>🏷️ Encontre os preços escaneando o código de barras.</li>
                            <li>🔄 Ofertas reais, com preços atualizados diariamente.</li>
                            <li>🛒 Não encontrou o preço na prateleira ou quer confirmar? É só escanear o código de barras com o TooMe!</li>
                            <li>📝 Inteligência também na sua Lista!
                                Além de cadastrar seus produtos favoritos e acompanhar os preços, você pode adicionar <b>todos de uma vez</b> usando sua nota de compra ou escaneando os códigos de barras.</li>

                        </ul>
                    </div>
                    <VideoEmbed
                        title={'Vídeo institucional do TooMe'}
                        videoId={yt_video_id}
                        className={'YT_VideoEmbed'}
                        thumbnailUrl={'https://i.ytimg.com/vi/a9j-EEOiWSU/hqdefault.jpg'}
                    />
                </section>

                <section className="pos-vantagens">
                    <div>
                        <h2>Economize até <span>75%</span> nos produtos do dia a dia</h2>
                        <p>Com o TooMe, você encontra as melhores ofertas nos mercados da sua cidade. Baixe agora ou cadastre-se gratuitamente!</p>
                        <div>
                            <a href={GLOBAL_LINKS_BAIXAR_APP} target='blank' className="botao-baixe">📲 Baixar o App</a>
                            <a href={GLOBAL_LINKS_CADASTRE_SE} className="botao-cadastre">📝 Cadastrar-se</a>
                        </div>
                    </div>
                </section>

                <section className='containe-diferenciais'>

                    <div>
                        <h2><u>O que torna o TooMe especial?</u></h2>
                        <p>O TooMe se diferencia de qualquer outro aplicativo de compras por unir tecnologia, colaboração entre usuários e inteligência de mercado, criando uma <b>experiência completa e recompensadora</b>.

                            Enquanto outros apps apenas mostram encartes, o TooMe centraliza tudo em um só lugar com funcionalidades inovadoras.</p>
                    </div>

                    <section className="diferenciais">

                        <div>

                            <div>
                                <div>🧠</div>
                                <h3>Economia Inteligente</h3>
                                <p>Com inteligência artificial, o TooMe - Tô no Mercado busca automaticamente os melhores preços.</p>
                            </div>


                            <div>
                                <div>💰</div>
                                <h3>Economia Real</h3>
                                <p>Com o TooMe, você pode economizar até 75% em diversos produtos, comparado a quem não usa o aplicativo!</p>
                            </div>

                            <div>
                                <div>📲</div>
                                <h3>Avisos Automatizados</h3>
                                <p>Ao passar perto de um mercado, receba encartes e promoções no celular. Mais praticidade, mais economia.</p>
                            </div>

                            <div>
                                <div>📍</div>
                                <h3>Centralização de Ofertas</h3>
                                <p>Os preços, ofertas e as melhores promoções de todos os mercados da sua região reunidos em um único aplicativo.</p>
                            </div>

                            <div>
                                <div>🗣️</div>
                                <h3>Mural Colaborativo</h3>
                                <p>Valorizamos a troca colaborativa de informações entre usuários, promovendo uma comunidade que se ajuda.</p>
                            </div>

                            <div>
                                <div>🔄</div>
                                <h3>Preços atualizados</h3>
                                <p>Acesse ofertas reais, com preços verificados e atualizados diariamente, garantindo economia de verdade todos os dias.</p>
                            </div>

                            <div>
                                <div>💬</div>
                                <h3>Comunicação Efetiva</h3>
                                <p>Os mercados podem se comunicar com você pelo Mapa das Ofertas e centralizar todas as promoções.</p>
                            </div>

                            <div>
                                <div>🌍</div>
                                <h3>Impacto Social</h3>
                                <p>A economia não é opcional, é essencial, e o TooMe proporciona praticidade e economia a milhares de pessoas.</p>
                            </div>

                        </div><br /><br />

                        <p>O TooMe transforma cada usuário em um consumidor inteligente, com poder de decisão, economia real e recompensas. <b>Não é apenas sobre ir ao mercado, é sobre ir melhor informado, gastar menos e ainda ganhar <b style={{ color: '#d65616e2' }}>vantagens</b> por isso</b>.</p>

                    </section>

                </section>

                <section className='localidades'>
                    <div>
                        <h3>ÁREA DE COBERTURA<br /> DO TOOME!</h3>
                        <p>Em breve, novas cidades!</p>
                    </div>

                    <p>📌 Toledo-PR</p>

                </section>

                <EstablishmentCards />

                <section id="qrcode" className="baixar">

                    <h2>Ainda não está usando o Tô No Mercado? Corre e baixe o aplicativo.</h2>

                    <div>
                        <section className="cadastrar">
                            <h3>Cadastre-se no TooMe!</h3>
                            <p>Preencha o formulário e começe a desfrutar de todo o escossistema que o Tô no Mercado oferece.</p>
                            <form onSubmit={handleSubmitCadastro} >
                                <div>
                                    <div>
                                        <label htmlFor="name">Nome</label>
                                        <input type="text" id="name" name="name" placeholder="Nome *" required />
                                    </div>
                                    <div>
                                        <label htmlFor="email">E-mail</label>
                                        <input type="email" name="email" id="email" placeholder="E-mail *" required />
                                    </div>
                                </div>
                                <div>
                                    <div style={{ width: 'calc(100% - 20px)' }}>
                                        <label htmlFor="refCode">Código de indicação</label>
                                        <input type="text" name="refCode" id="refCode" placeholder="Código de indicação?" />
                                    </div>
                                </div>
                                <button type="submit">📨 Cadastrar</button>
                            </form>
                        </section>

                        <div>
                            <img className="qr-code" src={require("./img/qr-code.png")} alt="Qrcode com link para baixar o aplicativo TooMe" loading='lazy' />
                            <img className="android" alt="Botão com logo da Play Store, para baixar o aplicativo TooMe" loading='lazy' target='blank' src={svg_android}
                                onClick={() => { window.open(GLOBAL_LINKS_BAIXAR_ANDROID, '_blank') }} />
                            <p>
                                Em breve para iOS. Enquanto isso, acesse a
                                <b style={{ cursor: 'pointer', color: 'gold', textDecoration: 'underline', margin: '0px 10px' }} onClick={utils_site_ref_launch_app}>versão web</b>
                                do app diretamente pelo seu celular.
                            </p>
                        </div>
                    </div>

                </section>

                <section className='apoio-toome-container'>

                    <div><p>Quem apoia o TooMe?</p></div>

                    <section className='apoio-toome'>
                        <div className='mouse-hover-apoio'>
                            <img
                                src={require('./img/unions1.png')}
                                alt="Logo da empresa Union's"
                                loading='lazy'
                                onClick={() => { window.open('https://uniions.com.br/', '_blank') }}
                                width={300}
                                height={200}
                            />
                        </div>
                        <div className='mouse-hover-apoio'>
                            <img
                                src={require('./img/sprint.png')}
                                alt="Logo da incubadora Sprint campus Toledo - Parná"
                                loading='lazy'
                                onClick={() => { window.open('https://sprint.td.utfpr.edu.br/', '_blank') }}
                                width={300}
                                height={200}
                            />
                        </div>
                    </section>

                </section>

                <Duvidas />

                <section className='espacamento'>
                    <div className='faq_section' id="js_container_fac">
                        <section className='espaco'>
                            <div className='faq_topic' name="faq_topic">
                                <li><b>O que é o TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe é um aplicativo que permite aos usuários buscar e compartilhar ofertas e promoções de supermercados, ganhando benefícios e com várias funcionalidades relevantes para o dia a dia de compras, ajudando-os a economizar tempo e dinheiro em suas compras diárias. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe é gratuito?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Sim, o TooMe é um aplicativo gratuito para download e uso. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como funcionam os jogos e desafios no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Com os jogos e desafios no TooMe, você ganha pontos que podem ser trocados por benefícios e, posteriormente, recompensas exclusivas. Além disso, você aprende práticas ambientais e de economia. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Para que servem os pontos no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, e de forma temporária, utilizamos pontos como recompensas. Esses pontos podem ser ganhos ao participar de jogos, programas de benefícios e desafios no TooMe, e utilizados para participar de sorteios(quando disponível), realizar buscas avançadas de preços e, futuramente, obter recompensas e produtos exclusivos dentro do aplicativo. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso compartilhar ofertas no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Você pode compartilhar ofertas no TooMe tirando uma foto e digitando os detalhes da oferta, que será então disponibilizada para outros usuários do aplicativo. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Eu ganho algo ao compartilhar ofertas no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, você ganhar pontos postando uma oferta. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe é seguro?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Sim, o TooMe prioriza a segurança dos dados dos usuários e implementa várias medidas de proteção para garantir a privacidade e segurança das informações, conforme nossos <Link style={{ color: '#d65616e2' }} to={LINKS_TERMOS}>Termos de Uso e Políticas de privacidades</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso encontrar as melhores ofertas perto de mim?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe utiliza as notificações do seu dispositivo para mostrar ofertas e promoções em supermercados próximos a você. Além disso, você pode personalizar a localidade que deseja ver, mudando a cidade na página inicial do aplicativo. Também é possível buscar produtos diretamente na barra de pesquisa, escrevendo o nome ou lendo o código de barras, e ativar as notificações clicando na opção "Perfil", no canto inferior direito da página principal do aplicativo.<a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe funciona em todas as cidades?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe já tem capacidade para funcionar em todo o Paraná e em alguns outros estados do país. No entanto, para testar o desempenho inicial, o lançamento está previsto apenas para a cidade de Toledo, no Paraná. Mas fique atento: o TooMe está continuamente trabalhando para expandir sua cobertura e incluir ofertas e promoções de supermercados em diversas cidades. Verifique a disponibilidade na sua região acessando a página principal do aplicativo. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Posso usar o TooMe para fazer compras online?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Atualmente, o TooMe é focado em buscas de ofertas e promoções em supermercados, mas futuras atualizações podem incluir funcionalidades para compras online.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso resgatar meus pontos?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, os pontos podem ser convertidos em consultas de preço e sorteios(quando disponível) e, posteriormente, em produtos exclusivos ou descontos que vão estar listados no aplicativo. Basta acessar a seção dos seus pontos. <a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'>Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O que acontece se eu encontrar uma oferta incorreta no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Você pode alertar o usuário sobre o imprevisto ou, em casos mais graves de postagens indevidas, denunciar ofertas incorretas diretamente na postagem. Nossa equipe irá revisar e remover a postagem caso necessário. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Posso sugerir novos recursos para o TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Sim, estamos sempre abertos a sugestões e feedback dos nossos usuários. Você pode enviar suas ideias através da opção <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe coleta meus dados pessoais?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe coleta apenas os dados necessários para fornecer um serviço eficaz e seguro, para que você obtenha todas as ofertas e promoções da sua localidade e tenha a melhor experiência possível no aplicativo. Todos os dados são tratados de acordo com os nossos <Link style={{ color: '#d65616e2' }} to={LINKS_TERMOS}>Termos de Uso e Políticas de privacidades</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como o TooMe aborda a sustentabilidade?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe atua nas três dimensões da sustentabilidade e contribui para diversos Objetivos de Desenvolvimento Sustentável (ODS) por meio das funcionalidades oferecidas no aplicativo. Você pode conferir, detalhadamente, acessando os <Link style={{ color: 'green' }} to={`..${LINKS_NAV_PARA_CLIENTES()}`} > IMPACTOS POSITIVOS</Link>, na seção
                                    <Link style={{ color: '#ff5500' }} to={`..${LINKS_NAV_PARA_CLIENTES()}`}> sobre nós</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como o TooMe se diferencia de outros aplicativos de compras?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe se destaca pela combinação única de compartilhamento colaborativo com foco na experiência do usuário e várias funcionalidades exclusivas, como: Mural de fertas, mapa das ofertas, Lista inteligente, encartes e ofertas por proximidade, e muitos outros, proporcionando uma abordagem inovadora para compras.<a style={{ color: '#d65616e2' }} href={GLOBAL_LINKS_BAIXAR_APP} target='blank'> Baixe</a> o aplicativo e conheça todas as funcionalidades do TooMe!</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso entrar em contato com o suporte do TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Você pode entrar em contato com o suporte do TooMe diretamente através do aplicativo ou enviando um e-mail para nossa equipe de atendimento ao cliente. Acessar a <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda</Link>.</p>
                            </div>

                        </section>
                    </div>
                </section>

                {/* <section className="contato">
                    <img
                        src={svg_pega_preco}
                        alt="Imagem do mascote do TooMe com nome de: Pega Preço"
                        loading='lazy'
                        width={240}
                        height={240}
                    />
                    <p>Pensou em ir ao mercado?<b> Pensou no TooMe!</b></p>
                </section> */}

                <FooterSiteV1 />
            </main>
            <SideMenu></SideMenu>
        </main >

        <PopUpIframe
            ref={iframeEncartesPopupRef}
            url={GLOBAL_LINKS_IFRAME_ENCATES()}
            title={'Encartes da sua região'}
        />
    </>
}